export default __webpack_public_path__ + "static/12-d5fdccc863b567fe1ca0aab537a3b002.png";